import { useMutation } from 'react-query'
import { sendToApi } from 'api/client'
import { SerpResponse } from 'components/Wizards/SEOPlanningWizard/SerpResponseType'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'

export const useSEOPlanningSearch = () =>
  useMutation('seoPlanningSearch', async (searchTerm: string) => {
    const query = encodeURIComponent(searchTerm)
    const response = await sendToApi<SerpResponse>(`/seo-planning/search?q=${query}`)
    if (response.type !== SUCCESS_RESPONSE_TYPE) {
      throw new Error()
    }
    return response.data
  })
